RivalIQ.module('settings', function (settings, App, Backbone, Marionette, $, _) {

    'use strict';

    /**
     * Displays an alert set on the server
     */
    function displayAlert() {
        const alertMsg = RivalIQ.state.account.get('alertMsg');
        if (!_.isEmpty(alertMsg)) {
            RivalIQ.execute(`alert:${alertMsg.type}`, alertMsg.message);
        }
    }

    (function () {

        let hasInitialized = false;

        App.commands.setHandler('settings:initialize', function (properties) {
            if (hasInitialized) {

                throw 'not supported: settings may only be initialized once';
            }

            const queryParams = new URLSearchParams(window.location.search);
            const isExporting = queryParams.get('format');
            const focusCompanyIdOverride = queryParams.get('focusCompanyId');
            if (isExporting && focusCompanyIdOverride !== null) {
                const focusCompanyId = Number(focusCompanyIdOverride);
                if (Number.isFinite(focusCompanyId)) {
                    properties.focusCompanyId = focusCompanyId;
                }
            }

            _.extend(settings, properties);

            // NOTE: order of initialization matters
            //
            // state.product stores (among other things) the current CSRF token. It must be
            // initialized before anything that might potentially make state-changing
            // API requests to the server (especially state.user and state.view which can
            // update server-side state during initialization).
            App.state.product.initialize(properties);
            App.state.companySets.initialize(properties);
            App.state.landscape.initialize(properties);
            App.state.timePeriods.initialize(properties);
            App.state.view.initialize(properties);
            App.state.account.initialize(properties);
            App.state.user.initialize(properties);
            App.state.branding.initialize(properties);
            App.state.plan.initialize(properties);
            App.state.session.initialize(properties);

            if (App.state.initializeDashboards) {
                App.state.initializeDashboards(properties);
            }

            displayAlert();

            App.hasInitialized = hasInitialized = true;

            App.trigger('state:initialized');
        });

    }());

});
